// 问题类型配置

const zyOptions_zh = [
    "其他",
    "项目管理",
    "总图",
    "建筑",
    "结构",
    "给排水",
    "暖通",
    "电气",
    "人防",
    "智能化",
    "BIM",
    "装配式",
    "景观",
    "精装",
    "规划",
    "经济",
    "钢结构",
    "综合机电",
    "幕墙",
]

const zyOptions_en = [
    "Others",
    "Project Management",
    "Site Planning",
    "Architecture",
    "Structure",
    "Water Supply and Drainage",
    "Heating, Ventilation, and Air Conditioning",
    "Electrical",
    "People Defense",
    "Intelligentization",
    "BIM",
    "Prefabricated",
    "Landscape",
    "Interior Decoration",
    "Planning",
    "Economics",
    "Steel Structure",
    "Integrated Mechanical and Electrical",
    "Facade",
]

export { zyOptions_zh, zyOptions_en }
